import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import markerDataReducer from './markerData';
import markerVisibleReducer from './markerVisible';
import shapeReducer from './shape';
import circleReducer from './circle';
import centerReducer from './center';
import loginReducer from './login';
import hanreiReducer from './hanrei';
import ppcReducer from './ppc';
import formatFileReducer from './formatFiles';
import linkDataReducer from './linkData';
import hainyoDataReducer from "./hainyoData";

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ["ppc"]
};

const rootReducer = combineReducers({
    markerData: markerDataReducer,
    markerVisible: markerVisibleReducer,
    shape: shapeReducer,
    circle: circleReducer,
    center: centerReducer,
    login: loginReducer,
    hanrei: hanreiReducer,
    ppc: ppcReducer,
    formatFile: formatFileReducer,
    linkData: linkDataReducer,
    hainyoData: hainyoDataReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
            }
        }),
    devTools: true
})

export const persistor = persistStore(store)

export default store;
